export default __webpack_public_path__ + "static/media/CKTL_demo_2.90620708.PNG";